import React from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CustomAccordion from '../../../CustomAccordion/CustomAccordion';

import "./PostOperativeManagement.scss"

const PostOperativeManagement = ({
  formData,
  form,
  arrayIndex,
  onChangeHandler,
  onRemoveHandler,
  onSubmitHandler,
  showToggleButtons = false,
  filterType = 'include',
  onFilterTypeChange = () => {},
  activeKey,
  onAccordionChange = () => {},
  closeFromBottom = false
}) => {
  const handleAccordionToggle = () => {
    onAccordionChange(form);
  };

  switch(form) {
    case "postOpPath": {
      return (
        <CustomAccordion
          title="Post-Op Path"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="post-operative-management"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
          <Form onSubmit={e => {e.preventDefault(); onSubmitHandler()}}>
            <Row>
              <Col>
                <Form.Label>Post-Op Path</Form.Label>
                <Form.Select
                  value={formData.postOpPath}
                  onChange={(e) => {onChangeHandler(arrayIndex, "postOpPath", e.target.value)}}
                >
                  <option value="" hidden>Select an option</option>
                  <option value="Inpatient">Inpatient</option>
                  <option value="Outpatient">Outpatient</option>
                  <option value="Outpatient-23 hour observation">Outpatient-23 hour observation</option>
                </Form.Select>
              </Col>
              <Col>
                <Form.Label>Inpatient stay (days)</Form.Label>
                <Form.Control
                  type="number"
                  step={1}
                  min={0}
                  max={365}
                  value={formData.inpatientStayDays}
                  onChange={(e) => {onChangeHandler(arrayIndex, "inpatientStayDays", e.target.value)}}
                ></Form.Control>
              </Col>
            </Row>
          </Form>
        </CustomAccordion>
      )
    }
    default: {
      return null
    }
  }
}

export default PostOperativeManagement